import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {ICcValorDistribuivelFilter} from "@models/contaContabil/Filters/ICcValorDistribuivelFilter.ts";
import {useEffect, useState} from "react";
import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {useCcDistribuibuivel} from "@components/contaContabil/valoresDistribuiveis/useCcDistribuibuivel.ts";
import {OpenInNew} from '@mui/icons-material'
import {CcDistribuivelRow} from "@components/contaContabil/valoresDistribuiveis/infoComponent/CcDistribuivelRow.tsx";
import {createSearchParams, Link} from "react-router";
import {_SitemapCc} from "@localization/siteMap/breadcrumbs/_Sitemap.ContaContabil.ts";
import {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateCcDistribuivel} from "@components/contaContabil/valoresDistribuiveis/CreateCcDistribuivel.tsx";

interface CcDistribuiveisPageProps extends DefaultPageProps {
    filtros?: ICcValorDistribuivelFilter,
    preset?: {
        contaContabil?: IContaContabil | number
    }
}

export function CcDistribuivelSelectionPage(props: CcDistribuiveisPageProps) {
    const {filtros, preset} = props
    const {getCcsValoresDistribuiveis} = useCcDistribuibuivel();
    const {addPopUp} = useAlert();

    const [ccs, setCcs] = useState<ICcValorDistribuivel[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});
    const [ccId, setCcId] = useState<number | null>()

    useEffect(() => {
        if (preset?.contaContabil != null) {
            if (typeof preset.contaContabil == 'number') {
                setCcId(preset.contaContabil)
            } else if (preset.contaContabil as IContaContabil != null) {
                setCcId((preset.contaContabil as IContaContabil).id)
            }
        }

    }, [preset]);

    useEffect(() => {
            if (pagination.page <= 0) {
                setPagination({...pagination, page: 1})
            }
            const ccf: number[] = filtros?.contaContabilId ? [...filtros.contaContabilId] : []
            if (ccId != null) ccf.push(ccId)

            getCcsValoresDistribuiveis({
                ...filtros,
                contaContabilId: ccf,
            }, pagination).then(x => {
                setCcs(x.items)
                setPagination(x.pagination)
            })
        },
        [pagination.page, filtros]
    )
    ;

    return <DefaultContainer pageProps={{pagination, setPagination}}
                             titulo={"Distribuição de valores conta contabil"}
                             UpperComponent={ccId != null &&
                                 <Grid container justifyContent={'space-between'} alignItems={'center'}>
                                     <Grid>
                                         <Button onClick={() => {
                                             addPopUp({
                                                 title: 'Criar valor distribuivel',
                                                 content: <CreateCcDistribuivel ContaContabilId={ccId}/>,
                                                 size: 'lg'
                                             })
                                         }} variant={'outlined'}>Criar valor</Button>
                                     </Grid>
                                     <Grid></Grid>
                                 </Grid>}>

        <TableContainer>
            <Table size={'small'} stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell>Valor</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Ativo</TableCell>
                        <TableCell>Criação</TableCell>
                        <TableCell>Inicio</TableCell>
                        <TableCell>Fim</TableCell>
                        <TableCell align={'right'}>Mais</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ccs.map(x => <CcDistribuivelRow EndComponent={(cc) => {
                        const sm = _SitemapCc.children
                        const sd: object = {contaContabilValorId: cc.id}

                        return (<IconButton size={'small'} component={Link} to={{
                            pathname: sm.valoresDistribuiveis.children.detalhes.fullUrl,
                            search: createSearchParams({...sd}).toString()
                        }}>
                            <OpenInNew/>
                        </IconButton>)
                    }} value={x} expectedId={x.id}/>)}
                </TableBody>
            </Table>
        </TableContainer>
    </DefaultContainer>
}